import React from "react";
import {
  Paper,
  Stack,
  Box,
  TextField,
  InputAdornment,
  Button,
  useTheme,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SearchIcon from "@mui/icons-material/Search";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export default function Controls({ date, setDate, q, setQ, onGetRecords }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Paper
      elevation={0}
     sx={{
    p: 2,
    marginY: 6,
    display: "flex",
    gap: 2,
    flexWrap: "wrap",
    alignItems: "center",
    background: isDark ? "rgba(28,33,43,0.8)" : "rgba(255,255,255,0.8)",
    border: `1px solid ${isDark ? "rgba(86,198,98,0.25)" : "#e5f6ee"}`,
    borderRadius: 3,
    boxShadow: "0 4px 18px rgba(16,185,129,0.06)",
    backdropFilter: "saturate(1.1)",
  }}
    >
      <Stack direction="row" gap={1} alignItems="center">
        <CalendarMonthIcon sx={{ color: "primary.main" }} />

        {/* Month-Year Picker */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            views={["year", "month"]}
            label="Payroll Month"
            value={date}
            onChange={(newValue) => setDate(newValue)}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  minWidth: 180,
                  "& .MuiOutlinedInput-root": {
                    border: `3px solid ${isDark ? "rgba(86,198,98,0.3)" : "#dcfce7"}`,
                    borderRadius: 1,
                    "& fieldset": { border: "none" },
                    "&.Mui-focused": { border: "3px solid #16a34a" },
                  },
                },
              },
            }}
          />
        </LocalizationProvider>

        {/* Get Records Button */}
        <Button
          variant="contained"
          color="success"
          onClick={onGetRecords}
         sx={{
    textTransform: "none",
    borderRadius: 2,
    px: 2.5,
    height: 40,
    boxShadow: "0 6px 14px rgba(16,185,129,0.2)",
  }}
        >
          Get Records
        </Button>
      </Stack>

      {/* Search Input */}
      <Box sx={{ flex: 1, minWidth: 240 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Search ID / name / role"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        sx={{
  minWidth: 180,
  "& .MuiOutlinedInput-root": {
    height: 40,
    border: `1.5px solid ${isDark ? "rgba(86,198,98,0.3)" : "#dcfce7"}`,
    borderRadius: 2,
    "& fieldset": { border: "none" },
    "&:hover": { borderColor: isDark ? "rgba(86,198,98,0.5)" : "#a7f3d0" },
    "&.Mui-focused": { border: "1.5px solid #10b981" },
  },
}}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Paper>
  );
}
